import { useEffect, useRef } from 'react'

import { useProfileCustomerToken } from '@cash-web/shared-data-access-core-profile'
import { useFeatureFlag } from '@cash-web/shared-data-access-feature-flags'
import { csrfTokenResponse, post, requestContextRequest } from '@cash-web/shared-util-fetch'

export const AccountAccessTokenExchange = () => {
  const { customerToken, isLoading, isFetching, error } = useProfileCustomerToken()
  const accessTokenExchangeEnabled = useFeatureFlag('cash-web-account-access-token-exchange-enabled') === true
  const attempted = useRef(false)
  const csrfToken = window.csrfToken

  useEffect(() => {
    if (
      attempted.current ||
      !accessTokenExchangeEnabled ||
      isLoading ||
      isFetching ||
      error ||
      !customerToken ||
      !csrfToken
    ) {
      return
    }
    attempted.current = true
    void post('/2.0/cash/web/exchange-session-token', undefined, {
      retry: false,
      optionalMiddleware: {
        accessTokenExchange: {
          // This endpoint has no request body and must not invalidate the existing session on failure.
          request: middleware => middleware.filter(handler => handler !== requestContextRequest),
          response: middleware => middleware.filter(handler => handler !== csrfTokenResponse),
        },
      },
    }).catch(() => {
      // This optional exchange must not interrupt the existing account session.
    })
  }, [accessTokenExchangeEnabled, isLoading, isFetching, error, customerToken, csrfToken])

  return null
}
